module.exports = __webpack_public_path__ + "static/img/fundamentals.e95f552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/screenshots/fundamentals.png
// module id = sZIE
// module chunks = 0